<h2 mat-dialog-title>{{ "HTL.HIL.createNewHil" | translate }}</h2>
<div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-left: 26px; margin-top: -20px">
    <div style="margin-right: 10px; font-size: medium">Aircraft Current Total Hours: {{ totalHours || 0 }}</div>
    @if (showFlightNumber) {
        <div style="margin-right: 10px; font-size: medium">Last Flight Number: {{ helicopterData?.flightNumber || 0 }}</div>
    }
    <div style="font-size: medium">Aircraft Current Total Cycles: {{ totalCycles || 0 }}</div>
</div>
<mat-dialog-content class="mat-typography">
    <form #hilForm="ngForm" fxFlex="100" (ngSubmit)="onFormSubmit()" [formGroup]="hilFormGroup">
        <app-form-group-title [title]="'HTL.HIL.holdItemListItem' | translate"></app-form-group-title>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.openingDate" | translate }}</mat-label>
                <input matInput [matDatepicker]="openingDatePicker" [placeholder]="'HTL.HIL.openingDate' | translate" name="openingDate" formControlName="openingDate" readonly />
                <mat-datepicker-toggle matSuffix [for]="openingDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #openingDatePicker></mat-datepicker>
                @if (hilFormGroup.controls["openingDate"].hasError("matDatepickerParse")) {
                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                }
                @if (hilFormGroup.controls["openingDate"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex="60" appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.description" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.description' | translate" name="description" formControlName="description" />
                @if (hilFormGroup.controls["description"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.ataChap" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.ataChap' | translate" name="ataChap" formControlName="ataChap" />
                @if (hilFormGroup.controls["ataChap"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.melRef" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.melRef' | translate" name="melRef" formControlName="melRef" />
                @if (hilFormGroup.controls["melRef"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
        <app-form-group-title [title]="'HTL.HIL.expectedExpiring' | translate"></app-form-group-title>
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="5px" class="overflow-wrap">
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.date" | translate }}</mat-label>
                <input matInput [matDatepicker]="expExpDatePicker" [placeholder]="'HTL.HIL.date' | translate" name="expExpDate" formControlName="expExpDate" readonly />
                <mat-datepicker-toggle matSuffix [for]="expExpDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #expExpDatePicker></mat-datepicker>
                @if (hilFormGroup.controls["expExpDate"].hasError("matDatepickerParse")) {
                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                }
                @if (hilFormGroup.controls["expExpDate"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.flightHours" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.flightHours' | translate" name="expExpFlightHours" formControlName="expExpFlightHours" />
                @if (hilFormGroup.controls["expExpFlightHours"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.flightNumber" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.flightNumber' | translate" name="expExpFlightNumber" formControlName="expExpFlightNumber" />
                @if (hilFormGroup.controls["expExpFlightNumber"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
            <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                <mat-label>{{ "HTL.HIL.cycles" | translate }}</mat-label>
                <input matInput [placeholder]="'HTL.HIL.cycles' | translate" name="expExpCycles" formControlName="expExpCycles" />
                @if (hilFormGroup.controls["expExpCycles"].hasError("required")) {
                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="hilForm.ngSubmit.emit()">
        {{ "GENERAL.save" | translate }}
    </button>
</mat-dialog-actions>
